import React from "react"

// Material-UI Core
import {makeStyles} from "@material-ui/core/styles"
import Snackbar from "@material-ui/core/Snackbar"

// Material-UI Lab
import MuiAlert from "@material-ui/lab/Alert"
import {AlertTitle} from "@material-ui/lab"

// Custom Style
import alertStyle from '../../styles/jss/components/alert/alertStyle'


const useStyles = makeStyles(theme => alertStyle(theme))

const CustomAlert = props => {
	return <MuiAlert elevation={10} variant="filled" {...props} />
}

const Alert = (props) => {
	const classes = useStyles()
	const {open, alertType, alertTitle, alertContent, handleClose} = props

	return (
		<div className={classes.root}>
			<Snackbar open={open} autoHideDuration={10000} onClose={handleClose}>
				<CustomAlert severity={alertType} onClose={handleClose}>
					<AlertTitle>{alertTitle}</AlertTitle>
					{alertContent}
				</CustomAlert>
			</Snackbar>
		</div>
	)
}


export {Alert}